.k4{pointer-events:auto;}